"use strict";
exports.__esModule = true;
exports.shouldTrackAwin = void 0;
var shouldTrackAwin = function (_a) {
    var _b = _a === void 0 ? {} : _a, awc = _b.awc;
    return !!awc && awc !== '';
};
exports.shouldTrackAwin = shouldTrackAwin;
